import { render, staticRenderFns } from "./DrillScoring.vue?vue&type=template&id=d2c86aae&scoped=true&lang=pug&"
import script from "./DrillScoring.vue?vue&type=script&lang=ts&"
export * from "./DrillScoring.vue?vue&type=script&lang=ts&"
import style0 from "./DrillScoring.vue?vue&type=style&index=0&id=d2c86aae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c86aae",
  null
  
)

export default component.exports